import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=71a1fb00&scoped=true&"
import script from "./ProductActions.vue?vue&type=script&lang=js&"
export * from "./ProductActions.vue?vue&type=script&lang=js&"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=71a1fb00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1fb00",
  null
  
)

export default component.exports